import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import MenuVariaveis from '../../../MenuVariaveis';
import HelpBallon from '../../../Intelligence/component/HelpBalloon/HelpBalloon';

export default (props) => {
  const { doUpdateItem, item, answerHandlerOpen } = props;

  const [GlpiSettings, setGlpiSettings] = useState({
    email: '',
    urgency: '',
    subject: '',
    group: '',
    comment: '',
    requirePassword: false,
  });

  useEffect(() => {
    if (item && item.glpi) {
      setGlpiSettings(item.glpi);
    }
  }, [item]);

  const { i18n } = useTranslation();

  const handleInputSettingsChange = (e) => {
    const { name, value } = e.target;
    const updatedSettings = { ...GlpiSettings, [name]: value };

    setGlpiSettings(updatedSettings);
    doUpdateItem({ glpi: updatedSettings });
  };

  const handleSelectVariavel = (name, value, variavel) => {
    const newValue = `${value}${variavel}`;
    const updatedSettings = { ...GlpiSettings, [name]: newValue };

    setGlpiSettings(updatedSettings);
    doUpdateItem({ glpi: updatedSettings });
  };

  const handleToggleQuickGlpi = (event) => {
    const { checked } = event.target;
    handleInputSettingsChange({
      target: { name: 'requirePassword', value: checked },
    });
  };

  return (
    <>
      <p className="handler-title">Criar Novo Ticket</p>

      <div className="form-group row mb-1">
        <div className="custom-control custom-switch mt-2">
          <input
            type="checkbox"
            className="custom-control-input"
            id="glpicreate"
            checked={GlpiSettings.requirePassword}
            onChange={handleToggleQuickGlpi}
          />
          <label
            className="custom-control-label quickAccess-label"
            htmlFor="glpicreate"
          >
            Login Necessário
          </label>

          <HelpBallon
            id="help-ballon-check-agente"
            message="Se ativo, Login e Senha tornam-se necessários."
          />
        </div>
      </div>

      <MenuVariaveis
        onSelect={(variavel) =>
          handleSelectVariavel('email', GlpiSettings.email, `{${variavel}}`)
        }
        buttonRight="27px"
        buttonBottom="25px"
        id={`bloco-${item._id}-configuracao-email`}
        isTooltip
        hidden={answerHandlerOpen}
      >
        <div className="common-form-group">
          <label>{i18n.t('E-mail')}</label>
          <input
            className="form-control mt-1"
            value={GlpiSettings.email || ''}
            name="email"
            onChange={(e) => handleInputSettingsChange(e)}
          />
        </div>
      </MenuVariaveis>

      <MenuVariaveis
        onSelect={(variavel) =>
          handleSelectVariavel('login', GlpiSettings.login, `{${variavel}}`)
        }
        buttonRight="27px"
        buttonBottom="25px"
        id={`bloco-${item._id}-configuracao-login`}
        isTooltip
        hidden={answerHandlerOpen}
      >
        <div className="common-form-group">
          <label>{i18n.t('Login')}</label>
          <input
            className="form-control mt-1"
            value={GlpiSettings.login || ''}
            name="login"
            onChange={(e) => handleInputSettingsChange(e)}
          />
        </div>
      </MenuVariaveis>

      <MenuVariaveis
        onSelect={(variavel) =>
          handleSelectVariavel(
            'password',
            GlpiSettings.password,
            `{${variavel}}`
          )
        }
        buttonRight="27px"
        buttonBottom="25px"
        id={`bloco-${item._id}-configuracao-password`}
        isTooltip
        hidden={answerHandlerOpen}
      >
        <div className="common-form-group">
          <label>{i18n.t('Senha')}</label>
          <input
            className="form-control mt-1"
            value={GlpiSettings.password || ''}
            name="password"
            onChange={(e) => handleInputSettingsChange(e)}
          />
        </div>
      </MenuVariaveis>

      <MenuVariaveis
        onSelect={(variavel) =>
          handleSelectVariavel('urgency', GlpiSettings.urgency, `{${variavel}}`)
        }
        buttonRight="27px"
        buttonBottom="25px"
        id={`bloco-${item._id}-configuracao-urgency`}
        isTooltip
        hidden={answerHandlerOpen}
      >
        <div className="common-form-group">
          <label>{i18n.t('Urgência')}</label>
          <input
            className="form-control mt-1"
            value={GlpiSettings.urgency || ''}
            name="urgency"
            onChange={(e) => handleInputSettingsChange(e)}
          />
        </div>
      </MenuVariaveis>

      <MenuVariaveis
        onSelect={(variavel) =>
          handleSelectVariavel('group', GlpiSettings.group, `{${variavel}}`)
        }
        buttonRight="27px"
        buttonBottom="25px"
        id={`bloco-${item._id}-configuracao-group`}
        isTooltip
        hidden={answerHandlerOpen}
      >
        <div className="common-form-group">
          <label>{i18n.t('Grupo')}</label>
          <input
            className="form-control mt-1"
            value={GlpiSettings.group || ''}
            name="group"
            onChange={(e) => handleInputSettingsChange(e)}
          />
        </div>
      </MenuVariaveis>

      <MenuVariaveis
        onSelect={(variavel) =>
          handleSelectVariavel('subject', GlpiSettings.subject, `{${variavel}}`)
        }
        buttonRight="27px"
        buttonBottom="25px"
        id={`bloco-${item._id}-configuracao-subject`}
        isTooltip
        hidden={answerHandlerOpen}
      >
        <div className="common-form-group">
          <label>{i18n.t('Assunto')}</label>
          <input
            className="form-control mt-1"
            value={GlpiSettings.subject || ''}
            name="subject"
            onChange={(e) => handleInputSettingsChange(e)}
          />
        </div>
      </MenuVariaveis>

      <MenuVariaveis
        onSelect={(variavel) =>
          handleSelectVariavel('comment', GlpiSettings.comment, `{${variavel}}`)
        }
        buttonRight="27px"
        buttonBottom="25px"
        id={`bloco-${item._id}-configuracao-comment`}
        isTooltip
        hidden={answerHandlerOpen}
      >
        <div className="common-form-group">
          <label>{i18n.t('Comentário')}</label>
          <textarea
            className="form-control mt-1"
            value={GlpiSettings.comment}
            name="comment"
            onChange={(e) => handleInputSettingsChange(e)}
          />
        </div>
      </MenuVariaveis>

      <div className="common-form-group">
        <label>Acesse a variável para vizualizar o id do Ticket Criado</label>
        <input
          className="form-control mt-1"
          defaultValue="{glpi.ticketId}"
          disabled
        />
      </div>
    </>
  );
};
